const API_ENDPOINTS = {
  prod: {
    LISTING_CONTACT: "/cms-constellation/api/listing-contact/"
  },
  dev: {
    LISTING_CONTACT: "/api/listing-contact/"
  },
  test: {
    LISTING_CONTACT: "/cms-constellation/api/listing-contact/"
  }
};
export {
  API_ENDPOINTS as default
};
